var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.75 0.5H5.25C2.29688 0.5 0 2.90625 0 5.75V44.25C0 47.2031 2.29688 49.5 5.25 49.5H50.75C53.5938 49.5 56 47.2031 56 44.25V5.75C56 2.90625 53.5938 0.5 50.75 0.5ZM5.25 47.75C3.28125 47.75 1.75 46.2188 1.75 44.25V38.6719L13.3438 27.0781C13.6719 26.75 14.2188 26.75 14.5469 27.0781L23.1875 35.7188L11.1562 47.75H5.25ZM54.25 44.25C54.25 46.2188 52.6094 47.75 50.75 47.75H13.5625L41.3438 20.0781C41.6719 19.75 42.2188 19.75 42.5469 20.0781L54.25 31.6719V44.25ZM54.25 29.2656L43.75 18.875C42.7656 17.7812 41.125 17.7812 40.1406 18.875L24.5 34.5156L15.75 25.7656C14.6562 24.7812 13.0156 24.7812 12.0312 25.7656L1.75 36.2656V5.75C1.75 3.89062 3.28125 2.25 5.25 2.25H50.75C52.6094 2.25 54.25 3.89062 54.25 5.75V29.2656ZM14 8.375C10.6094 8.375 7.875 11.2188 7.875 14.5C7.875 17.8906 10.6094 20.625 14 20.625C17.2812 20.625 20.125 17.8906 20.125 14.5C20.125 11.2188 17.2812 8.375 14 8.375ZM14 18.875C11.4844 18.875 9.625 17.0156 9.625 14.5C9.625 12.0938 11.4844 10.125 14 10.125C16.4062 10.125 18.375 12.0938 18.375 14.5C18.375 17.0156 16.4062 18.875 14 18.875Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaImage);
export default __webpack_public_path__ + "static/media/fa-image.5ece7c8b1e2d3215965d8f45fd0a49da.svg";
export { ForwardRef as ReactComponent };